// Generated by purs version 0.15.16
import * as App_Operation_Store from "../App.Operation.Store/index.js";
import * as App_Route from "../App.Route/index.js";
import * as App_Step from "../App.Step/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
var Step3NotLoaded = /* #__PURE__ */ (function () {
    function Step3NotLoaded() {

    };
    Step3NotLoaded.value = new Step3NotLoaded();
    return Step3NotLoaded;
})();
var Step3LoadingFormTypes = /* #__PURE__ */ (function () {
    function Step3LoadingFormTypes(value0) {
        this.value0 = value0;
    };
    Step3LoadingFormTypes.create = function (value0) {
        return new Step3LoadingFormTypes(value0);
    };
    return Step3LoadingFormTypes;
})();
var Step3LoadingInitialState = /* #__PURE__ */ (function () {
    function Step3LoadingInitialState(value0) {
        this.value0 = value0;
    };
    Step3LoadingInitialState.create = function (value0) {
        return new Step3LoadingInitialState(value0);
    };
    return Step3LoadingInitialState;
})();
var Step3Ready = /* #__PURE__ */ (function () {
    function Step3Ready(value0) {
        this.value0 = value0;
    };
    Step3Ready.create = function (value0) {
        return new Step3Ready(value0);
    };
    return Step3Ready;
})();
var Step2BNotLoaded = /* #__PURE__ */ (function () {
    function Step2BNotLoaded() {

    };
    Step2BNotLoaded.value = new Step2BNotLoaded();
    return Step2BNotLoaded;
})();
var Step2BLoading = /* #__PURE__ */ (function () {
    function Step2BLoading(value0) {
        this.value0 = value0;
    };
    Step2BLoading.create = function (value0) {
        return new Step2BLoading(value0);
    };
    return Step2BLoading;
})();
var Step2BReady = /* #__PURE__ */ (function () {
    function Step2BReady(value0) {
        this.value0 = value0;
    };
    Step2BReady.create = function (value0) {
        return new Step2BReady(value0);
    };
    return Step2BReady;
})();
var Step2BLoadFailed = /* #__PURE__ */ (function () {
    function Step2BLoadFailed(value0) {
        this.value0 = value0;
    };
    Step2BLoadFailed.create = function (value0) {
        return new Step2BLoadFailed(value0);
    };
    return Step2BLoadFailed;
})();
var Step2ANotLoaded = /* #__PURE__ */ (function () {
    function Step2ANotLoaded() {

    };
    Step2ANotLoaded.value = new Step2ANotLoaded();
    return Step2ANotLoaded;
})();
var Step2ALoading = /* #__PURE__ */ (function () {
    function Step2ALoading(value0) {
        this.value0 = value0;
    };
    Step2ALoading.create = function (value0) {
        return new Step2ALoading(value0);
    };
    return Step2ALoading;
})();
var Step2AReady = /* #__PURE__ */ (function () {
    function Step2AReady(value0) {
        this.value0 = value0;
    };
    Step2AReady.create = function (value0) {
        return new Step2AReady(value0);
    };
    return Step2AReady;
})();
var Step2ALoadFailed = /* #__PURE__ */ (function () {
    function Step2ALoadFailed(value0) {
        this.value0 = value0;
    };
    Step2ALoadFailed.create = function (value0) {
        return new Step2ALoadFailed(value0);
    };
    return Step2ALoadFailed;
})();
var Step1NotLoaded = /* #__PURE__ */ (function () {
    function Step1NotLoaded() {

    };
    Step1NotLoaded.value = new Step1NotLoaded();
    return Step1NotLoaded;
})();
var Step1Loading = /* #__PURE__ */ (function () {
    function Step1Loading(value0) {
        this.value0 = value0;
    };
    Step1Loading.create = function (value0) {
        return new Step1Loading(value0);
    };
    return Step1Loading;
})();
var Step1Ready = /* #__PURE__ */ (function () {
    function Step1Ready(value0) {
        this.value0 = value0;
    };
    Step1Ready.create = function (value0) {
        return new Step1Ready(value0);
    };
    return Step1Ready;
})();
var PushRouteHistory = /* #__PURE__ */ (function () {
    function PushRouteHistory() {

    };
    PushRouteHistory.value = new PushRouteHistory();
    return PushRouteHistory;
})();
var ReplaceRouteHistory = /* #__PURE__ */ (function () {
    function ReplaceRouteHistory() {

    };
    ReplaceRouteHistory.value = new ReplaceRouteHistory();
    return ReplaceRouteHistory;
})();
var step3InitForState = function (state) {
    var currentDoc = (function () {
        if (state.step instanceof App_Step.Step3Doc) {
            return Steps_WorkQueue_Cache.getDoc(state.workQueueState)(state.step.value0);
        };
        return Data_Maybe.Nothing.value;
    })();
    return {
        doc: currentDoc,
        formType: Data_Maybe.Nothing.value,
        initialAnchor: (function () {
            if (state.route instanceof App_Route.RStep3 && state.route.value0.section instanceof App_Route.SectionSet) {
                return new Data_Maybe.Just(state.route.value0.section.value0);
            };
            return Data_Maybe.Nothing.value;
        })()
    };
};
var step3SessionForState = function (state) {
    if (state.step instanceof App_Step.Step3) {
        return new Step3LoadingFormTypes({
            init: step3InitForState(state),
            opId: Data_Maybe.Nothing.value
        });
    };
    if (state.step instanceof App_Step.Step3Doc) {
        return new Step3LoadingFormTypes({
            init: step3InitForState(state),
            opId: Data_Maybe.Nothing.value
        });
    };
    return Step3NotLoaded.value;
};
var step2BSessionForState = function (state) {
    if (state.step instanceof App_Step.Step2B) {
        return new Step2BLoading({
            workQueueState: state.workQueueState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            opId: Data_Maybe.Nothing.value
        });
    };
    return Step2BNotLoaded.value;
};
var step2ASessionForState = function (state) {
    if (state.step instanceof App_Step.Step2A) {
        return new Step2ALoading({
            workQueueState: state.workQueueState,
            workQueueCache: state.workQueueCache,
            opId: Data_Maybe.Nothing.value
        });
    };
    return Step2ANotLoaded.value;
};
var step1InitForState = function (state) {
    return {
        workQueueState: state.workQueueState,
        workQueueUi: state.workQueueUi,
        workQueueCache: state.workQueueCache,
        preselectForms: state.preselectForms
    };
};
var step1SessionForState = function (previous) {
    return function (nextState) {
        if (nextState.step instanceof App_Step.Step1) {
            if (previous.step1 instanceof Step1Ready) {
                if (previous.step instanceof App_Step.Step1) {
                    return new Step1Ready({
                        recentForms: previous.step1.value0.recentForms,
                        selection: previous.step1.value0.selection,
                        formPicker: previous.step1.value0.formPicker,
                        state: previous.step1.value0.state,
                        searchVersion: previous.step1.value0.searchVersion,
                        searchState: nextState.workQueueUi.search
                    });
                };
                return new Step1Loading({
                    init: step1InitForState(nextState),
                    opId: Data_Maybe.Nothing.value
                });
            };
            return new Step1Loading({
                init: step1InitForState(nextState),
                opId: Data_Maybe.Nothing.value
            });
        };
        return Step1NotLoaded.value;
    };
};
var syncStepSessions = function (previous) {
    return function (nextState) {
        return {
            route: nextState.route,
            step: nextState.step,
            workQueueState: nextState.workQueueState,
            workQueueUi: nextState.workQueueUi,
            workQueueCache: nextState.workQueueCache,
            preselectForms: nextState.preselectForms,
            pushStateInterface: nextState.pushStateInterface,
            operations: nextState.operations,
            routeVersion: nextState.routeVersion,
            step1: step1SessionForState(previous)(nextState),
            step2A: step2ASessionForState(nextState),
            step2B: step2BSessionForState(nextState),
            step3: step3SessionForState(nextState)
        };
    };
};
var setStep3Session = function (step3) {
    return function (state) {
        return {
            route: state.route,
            step: state.step,
            workQueueState: state.workQueueState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            routeVersion: state.routeVersion,
            step3: step3
        };
    };
};
var initialAppState = function (init) {
    var state = {
        route: init.route,
        step: init.step,
        workQueueState: init.workQueueState,
        workQueueUi: init.workQueueUi,
        workQueueCache: init.workQueueCache,
        preselectForms: init.preselectForms,
        pushStateInterface: init.pushStateInterface,
        operations: App_Operation_Store.emptyOperationStore,
        step1: Step1NotLoaded.value,
        step2A: Step2ANotLoaded.value,
        step2B: Step2BNotLoaded.value,
        step3: Step3NotLoaded.value,
        routeVersion: 0
    };
    return syncStepSessions(state)(state);
};
var activateStep = function (step) {
    return function (state) {
        return syncStepSessions(state)({
            route: state.route,
            workQueueState: state.workQueueState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            step: step
        });
    };
};
export {
    PushRouteHistory,
    ReplaceRouteHistory,
    Step1NotLoaded,
    Step1Loading,
    Step1Ready,
    Step2ANotLoaded,
    Step2ALoading,
    Step2AReady,
    Step2ALoadFailed,
    Step2BNotLoaded,
    Step2BLoading,
    Step2BReady,
    Step2BLoadFailed,
    Step3NotLoaded,
    Step3LoadingFormTypes,
    Step3LoadingInitialState,
    Step3Ready,
    step1InitForState,
    initialAppState,
    syncStepSessions,
    activateStep,
    setStep3Session
};
//# sourceMappingURL=index.js.map
